"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayerFromType = void 0;
var types_1 = require("../types");
var containers_1 = require("./containers");
var routes_1 = require("./routes");
var depots_1 = require("./depots");
var inquiries_1 = require("./inquiries");
var vehicles_1 = require("./vehicles");
var stops_1 = require("./stops");
var filledlevel_1 = require("./filledlevel");
var layerTypeMap = (_a = {},
    _a[types_1.PointType.Containers] = containers_1.getcontainerSource,
    _a[types_1.PointType.Routes] = routes_1.getRouteSource,
    _a[types_1.PointType.Depots] = depots_1.getDepotSource,
    _a[types_1.PointType.Inquiries] = inquiries_1.getInquirySource,
    _a[types_1.PointType.Vehicles] = vehicles_1.getVehicleSource,
    _a[types_1.PointType.Stops] = stops_1.getStopsSource,
    _a[types_1.PointType.FilledLevels] = filledlevel_1.getFilledLevelSource,
    _a);
var getLayerFromType = function (type) {
    return layerTypeMap[type];
};
exports.getLayerFromType = getLayerFromType;
